import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import round from 'utils/round';
import './ConversationStyleTooltipContent.styl';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class ConversationStyleTooltipContent extends React.PureComponent {
  render() {
    const {user, listenPercentage, interchangesPerMinuteAvg} = this.props;
    const talkPercentage = 100 - listenPercentage;
    return (
      <div className="conversation-style-tooltip-content">
        <a href="javascript:;" onClick={this.props.onClick}>
          <UserAvatar user={user} />
          <div>
            <strong>{user.getFullName()}</strong>
            <div>
              Average ratio: {round(listenPercentage)}% listen ({round(talkPercentage)}% talk)
            </div>
            <div>Interchanges (min): {round(interchangesPerMinuteAvg)}</div>
          </div>
        </a>
      </div>
    );
  }
}
